import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FormField, TabsTimelineSub, Upload } from 'components';
import { isAuditor, isAuditorFinal, isCommittee, isCommitteeFinal, isInvestor, isObjection, isObjectionCommittee, isObjectionCommitteeFinal, isDocumentsUpload, isOperator, isCommitteeAfterOperations, isCommitteeAfterOperationsFinal, isObjectionDocuments, isObjectionDocumentsCommittee, isObjectionDocumentsCommitteeFinal, isBeneficiary } from 'utils';
import { DownloadedItems } from './components/index';
import { flattenDocs } from './utils';
import DocsInvestor from './components/docsInvestor';
import { isEmpty, omit } from 'lodash';
import { Col, Empty, Form, Row } from 'antd';
import { content, content_only_kindergarten, content_optional, content_pea, formFields } from './components/docsInvestor/content';
import { useForm } from 'antd/lib/form/Form';

const DocumentsBeneficiary = () => {
  const dispatch = useDispatch();
  const form = useForm();
  const docs = useSelector(state => state.forms.documents);
  const task = useSelector(state => state.forms.task);
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const flatDocs = flattenDocs(docs);
  const user = useSelector(state => state.user);
  const schoolGrade = useSelector(state => state.forms.carrier.schoolGrade);

  const kindergarten = schoolGrade == "Παιδικός Σταθμός";

  const documents = useSelector(state => state.forms.documents)

  return !viewMode && isBeneficiary(user?.groups) ? (
    <div>
      <div className="mt-6"/>
      <DocsInvestor group={'documents'} />
      <div className="mt-2 " />
    </div>
  ) 
    :
    (
    <div style={{minHeight:"500px"}}  >
      <div className="mt-6"/>
      {
        isEmpty(documents) ?
        <div style={{position:"absolute", top:"10%", left:"50%"}}>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<>No data</>} />
        </div>
        :
        <DocsInvestor group={'documents'} />
      }
    </div>
  );
};

DocumentsBeneficiary.propTypes = {
  group: PropTypes.string.isRequired,
};

export default DocumentsBeneficiary;
